import { render } from "./VideoIcon.vue?vue&type=template&id=cf3edaf0"
const script = {}

import exportComponent from "/home/runner/work/margaretriver.com/margaretriver.com/river/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__